import AudienceStepComponentView from './AudienceStepComponentView.html';
import './AudienceStepComponent.scss';
import { ActiveMessagesConstants } from '../../ActiveMessagesConstants';
import { GROWTH_ACTIVE_MESSAGE_WA_CONTENT_STEP_STARTED, GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_STEP_HELP_SPREEDSHEET_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_ERROR, GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_WARNING, } from '../../../GrowthSegmentEvents';
import { ERROR_CODE_PARAMETERS, INVALID_ENCODING, MAX_FILE_SIZE, FIELD_ERROR_TO_ALERT } from '../../models/ErrorCodes';
import { ToastType } from 'modules/application/misc/ToastService';
import { ActiveMessagesFeatures } from '../../ActiveMessagesFeatures';
import { CampaignType } from '../../models/CampaignType';
import { isNullOrWhiteSpace } from 'data/string';
class AudienceStepComponentController {
    static $inject = ['$translate', 'GrowthSegmentService', 'ApplicationService2', 'ActiveMessageService', 'LoadingService', 'BlipToastService', 'AlertService', '$stateParams', 'UsersService', '$rootScope'];
    constructor($translate, GrowthSegmentService, ApplicationService2, ActiveMessageService, LoadingService, BlipToastService, AlertService, $stateParams, UsersService, $rootScope) {
        'ngInject';
        this.$translate = $translate;
        this.GrowthSegmentService = GrowthSegmentService;
        this.ApplicationService2 = ApplicationService2;
        this.ActiveMessageService = ActiveMessageService;
        this.LoadingService = LoadingService;
        this.BlipToastService = BlipToastService;
        this.AlertService = AlertService;
        this.$stateParams = $stateParams;
        this.UsersService = UsersService;
        this.$rootScope = $rootScope;
        this.linkUri = '';
        this.isAiAgent = false;
        this.isSelectedAudience = false;
        this.isBotRouter = false;
        this.isBotAiAgent = false;
        this.isToShowAiOptions = false;
        this.onSelectOption = (event) => {
            const { detail: { value }, } = event;
            this.isAiAgent = false;
            this.campaignTypeOption = value === '' ? undefined : value;
            if (value == CampaignType.AiAgentBatch.valueOf() || value == CampaignType.AiAgentIndividual.valueOf()) {
                this.isAiAgent = true;
            }
            if (value.includes(CampaignType.Batch.valueOf())) {
                this.loadFile = true;
                this.cleanPhoneNumber();
                this.cleanGroup();
            }
            else if (value.includes(CampaignType.Individual.valueOf())) {
                this.loadFile = false;
                this.cleanGroup();
                this.onFileDelete(undefined);
            }
            else {
                this.loadFile = false;
                this.cleanPhoneNumber();
                this.onFileDelete(undefined);
                this.isGroup = true;
            }
        };
        this.onSelectGroupOption = (event) => {
            const { detail: { value }, } = event;
            this.groupValue = value === '' ? undefined : value;
            this.groupSelected = this.validateGroup();
            this.validGroup = this.groupSelected ? true : false;
        };
        this.verifyPhoneNumber = (event) => {
            const { detail: { value, code, country }, } = event;
            this.phoneNumber = value === '' || isNaN(value)
                ? ''
                : value;
            this.phoneNumberCountry = isNullOrWhiteSpace(country)
                ? ''
                : country.replace('-flag', '');
            if (this.isInternationalPhoneNumberActive) {
                this.validPhoneNumber = this.validatePhoneNumberAllowingInternationalNumbers(this.phoneNumber, code);
            }
            else {
                this.validPhoneNumber = code === '+55'
                    ? this.phoneNumber.length === ActiveMessagesConstants.PHONE_NUMBER_LENGTH
                    : false;
            }
            this.phoneNumber = code + this.phoneNumber;
        };
        this.onFileDelete = (event) => {
            this.loadTranslations();
            const inputFileAudience = document.getElementById('fileAudienceInput');
            if (inputFileAudience) {
                inputFileAudience.value = '';
            }
            this.fileAudienceUrl = undefined;
            this.fileAudience = undefined;
            this.fileWarningList = [];
            this.fileErrorList = [];
            this.LoadingService.stopLoading();
        };
        this.validateNextStep = () => {
            if (this.fileErrorList && this.fileErrorList.length > 0) {
                return false;
            }
            return this.validPhoneNumber
                || ((this.campaignTypeOption === CampaignType.Batch || this.campaignTypeOption === CampaignType.AiAgentBatch) && this.fileAudienceUrl) || this.validGroup;
        };
        this.handleNextStep = () => {
            const $data = {
                name: this.audienceTitle,
                value: [{
                        description: this.phoneNumber || this.fileAudience?.name || this.groupSelected?.identity.split('@')[0],
                    }],
                params: {
                    countryNumber: this.phoneNumberCountry,
                    groupName: this.groupSelected?.name,
                },
                campaignType: this.campaignTypeOption.split(':')[0],
                fileUrl: this.fileAudienceUrl,
                fileSummary: this.fileSummary,
                applicationOrigin: this.applicationOrigin,
            };
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CONTENT_STEP_STARTED, { activeMessageType: this.campaignTypeOption, country: this.phoneNumberCountry });
            this.callback({ $data });
            this.onUpdate({ isGroup: this.isGroup });
            this.onUpdateAiAgent({ isAiAgent: this.isAiAgent });
            this.next();
        };
    }
    async $onInit() {
        if (this.$stateParams.fileName && this.$stateParams.mediaUrl) {
            this.fileAudienceUrl = this.$stateParams.mediaUrl;
            this.fileAudience = new File([], this.$stateParams.fileName);
            this.campaignTypeOption = CampaignType.Batch;
            await this.validateAudienceAsync();
            this.cleanPhoneNumber();
            this.cleanGroup();
            this.loadFile = true;
        }
        this.applicationOrigin = this.$stateParams?.applicationOrigin || ActiveMessagesConstants.APPLICATION_ORIGIN;
        this.batchActiveMessageFeature = await ActiveMessagesFeatures.isBatchActiveMessageEnabled();
        this.isInternationalPhoneNumberActive = await ActiveMessagesFeatures.isInternationalPhoneNumberActive();
        this.changesDisplayActiveCampaignData = await ActiveMessagesFeatures.isChangesDisplayActiveCampaignData();
        const showGroupActiveMessage = await ActiveMessagesFeatures.isGrouphActiveMessageEnabled();
        const showWhatsAppGroup = await ActiveMessagesFeatures.isShowWhatsAppGroupViewEnabled();
        this.groupActiveMessageFeature = showGroupActiveMessage && showWhatsAppGroup;
        await this.loadTranslations();
        await this.getGroups();
        this.isToShowAiOptions = this.isBotRouter || this.isBotAiAgent;
    }
    cleanGroup() {
        this.isGroup = false;
        this.groupValue = undefined;
        this.groupSelected = undefined;
        this.validGroup = false;
    }
    cleanPhoneNumber() {
        const teste = document.getElementById('input-number-wa');
        teste.setAttribute('value', '');
        this.phoneNumber = undefined;
        this.phoneNumberCountry = undefined;
        this.validPhoneNumber = false;
    }
    isSingleBroadcast() {
        return this.campaignTypeOption === CampaignType.Individual || this.campaignTypeOption === CampaignType.AiAgentIndividual;
    }
    isTypeSelected() {
        return !(!this.campaignTypeOption || 0 === this.campaignTypeOption.length);
    }
    async loadTranslations() {
        this.phoneNumberLabel = await this.$translate('activeMessages.send.audience.select.inputPhone.label');
        this.phoneNumberErrorMessage = await this.$translate('activeMessages.send.audience.select.inputPhone.errorMessage');
        this.audienceTitle = await this.$translate('activeMessages.send.audience.title');
    }
    async getGroups() {
        if (!this.groupActiveMessageFeature) {
            return;
        }
        this.createUri();
        const query = "(source eq 'WhatsApp Group')";
        const filter = `&$filter=${encodeURIComponent(query)}`;
        this.groupList = await this.UsersService.getUsers(filter, 0, 1024);
        this.groupOptions = this.groupList.items.map((group) => {
            return {
                label: group.name,
                value: group.identity,
            };
        });
        this.hasGroups = this.groupList.total > 0;
    }
    createUri() {
        const output = window.location.pathname.split('/activemessages')[0];
        this.linkUri = ('https://' + window.location.host + output + '/groups');
    }
    validateGroup() {
        return this.groupList.items.find((group) => group.identity === this.groupValue);
    }
    validatePhoneNumberAllowingInternationalNumbers(phone, code) {
        const cleanPhoneNumberLength = phone.length + code.length - 1;
        return cleanPhoneNumberLength <= ActiveMessagesConstants.INTERNATIONAL_PHONE_NUMBER_MAX_LENGTH
            && cleanPhoneNumberLength >= ActiveMessagesConstants.INTERNATIONAL_PHONE_NUMBER_MIN_LENGTH;
    }
    showFileDialog() {
        document.getElementById('fileAudienceInput').click();
    }
    async importFileAudience() {
        this.LoadingService.startLoading();
        const CSV_MIME_TYPES = ActiveMessagesConstants.CSV_MIME_TYPES;
        if ((this.fileAudience.type && !CSV_MIME_TYPES.includes(this.fileAudience.type)) || (this.fileAudience.type == '' && this.fileAudience.name.slice(-4) != '.csv')) {
            this.BlipToastService.show(ToastType.Danger, {
                title: await this.$translate('activeMessages.send.audience.fileSummaryError.csvFormat.title'),
                msg: await this.$translate('activeMessages.send.audience.fileSummaryError.csvFormat.message', ERROR_CODE_PARAMETERS),
            });
            this.onFileDelete(undefined);
            this.LoadingService.stopLoading();
            return;
        }
        if (this.fileAudience.size > ERROR_CODE_PARAMETERS.maxFileSize) {
            this.BlipToastService.show(ToastType.Danger, {
                title: await this.$translate(`activeMessages.send.audience.fileSummaryError.${MAX_FILE_SIZE}.title`),
                msg: await this.$translate(`activeMessages.send.audience.fileSummaryError.${MAX_FILE_SIZE}.message`, ERROR_CODE_PARAMETERS),
            });
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_ERROR, { errorType: MAX_FILE_SIZE });
            this.onFileDelete(undefined);
            this.LoadingService.stopLoading();
            return;
        }
        try {
            this.fileWarningList = [];
            this.fileErrorList = [];
            this.fileAudienceUrl = await this.ApplicationService2.uploadFile(this.fileAudience, { secure: false, type: 'text/csv' });
            await this.validateAudienceAsync();
        }
        catch (e) {
            throw e;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async validateAudienceAsync() {
        this.fileSummary = await this.ActiveMessageService.setValidateAudienceFile(this.fileAudienceUrl);
        if (this.changesDisplayActiveCampaignData) {
            this.fileSummary.audienceSize = this.fileSummary.linesCount - this.fileSummary.linesBlankCount - this.fileSummary.linesErrorsCount - this.fileSummary.linesRepeatCount;
        }
        FIELD_ERROR_TO_ALERT.forEach(async (fieldError) => {
            if (this.fileSummary[fieldError] > 0) {
                const translatePlural = this.fileSummary[fieldError] > 1 ? 'other' : '1';
                let str = await this.$translate(`activeMessages.send.audience.warningText.${fieldError}.${translatePlural}`, this.fileSummary);
                str = str.replace(`{{${fieldError}}}`, this.fileSummary[fieldError]);
                this.fileWarningList.push(str);
                this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_WARNING, { errorType: fieldError });
            }
        });
        if (!this.fileSummary.linesCount || (this.fileSummary.linesCount - this.fileSummary.linesBlankCount) < 1) {
            this.fileErrorList.push(await this.$translate('activeMessages.send.audience.errorText.errorNoHeaderOrLine'));
        }
        if (!this.fileSummary.isHealthy && this.fileSummary.unhealthyReasonCode && this.fileSummary.unhealthyReasonCode.length > 0) {
            this.onFileDelete(undefined);
            this.fileSummary.unhealthyReasonCode.forEach(async (reasonCode) => {
                if (reasonCode != INVALID_ENCODING) {
                    this.BlipToastService.show(ToastType.Danger, {
                        title: await this.$translate(`activeMessages.send.audience.fileSummaryError.${reasonCode}.title`),
                        msg: await this.$translate(`activeMessages.send.audience.fileSummaryError.${reasonCode}.message`, ERROR_CODE_PARAMETERS),
                    });
                    this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_ERROR, { errorType: reasonCode });
                }
                else {
                    this.toggleEncondingAlert();
                    this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_ERROR, { errorType: INVALID_ENCODING });
                }
            });
        }
    }
    async toggleEncondingAlert() {
        const alertTitle = await this.$translate('activeMessages.send.audience.fileSummaryError.AC05.title');
        const alertBody = await this.$translate('activeMessages.send.audience.fileSummaryError.AC05.message');
        const confirmButton = await this.$translate('activeMessages.send.audience.fileSummaryError.confirmation');
        await this.AlertService.show({
            title: alertTitle,
            body: alertBody,
            variant: 'error',
            icon: 'attention',
            buttons: {
                confirm: confirmButton,
            },
            callback: {
                confirmButtonAction: () => { },
            },
        });
    }
    onClickHelpFileMessage() {
        this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_AUDIENCE_STEP_HELP_SPREEDSHEET_BUTTON_CLICKED, { activeMessageType: this.campaignTypeOption });
    }
}
AudienceStepComponentController.$inject = ['$translate', 'GrowthSegmentService', 'ApplicationService2', 'ActiveMessageService', 'LoadingService', 'BlipToastService', 'AlertService', '$stateParams', 'UsersService', '$rootScope'];
export const AudienceStep = {
    template: AudienceStepComponentView,
    controller: AudienceStepComponentController,
    controllerAs: '$ctrl',
    bindings: {
        step: '@?',
        next: '&?',
        callback: '&?',
        onUpdate: '&?',
        onUpdateAiAgent: '&?',
        isBotRouter: '<?',
        isBotAiAgent: '<?',
    },
};
